import React from "react";

const IconLabel = ({ icon = null, label, href }) => {
  return (
    <div className="flex flex-row space-x-2 items-center">
      {icon && <span className="text-lg">{icon}</span>}
      {href ? (
        <a className="text-sm md:text-base text-white font-medium" href={href}>
          {label}
        </a>
      ) : (
        <h2 className="text-sm md:text-base text-white font-medium">{label}</h2>
      )}
    </div>
  );
};

export default IconLabel;
